import { render, staticRenderFns } from "./ck.vue?vue&type=template&id=71f985da&scoped=true&"
import script from "./ck.vue?vue&type=script&lang=js&"
export * from "./ck.vue?vue&type=script&lang=js&"
import style0 from "./ck.vue?vue&type=style&index=0&id=71f985da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f985da",
  null
  
)

export default component.exports